import type { Me } from '@/types/access';
import apiClient from './axios';

export async function fetchMe(): Promise<Me> {
  const { data } = await apiClient.get<Me>('/me', { skipGlobalError: true });
  return data;
}
